import { Flex, Typography } from 'antd';
import { COLOR_OPTIONS } from 'config/style';
import styled from 'styled-components';

export const SidebarContainer = styled(Flex).attrs({ vertical: true })`
  width: 293px;
  border-right: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};
  padding-top: 16px;
  flex-grow: 0;

  @media (max-width: 768px) {
    width: auto;
    margin: 0 16px 16px;
    border: 1px solid ${COLOR_OPTIONS.NEUTRAL_30};
    border-radius: 8px;
    box-shadow: 0px 2px 4px rgba(92, 101, 117, 0.3), 0px 0px 1px rgba(92, 101, 117, 0.47);
  }
`;

export const SelectWrapper = styled.div`
  padding: 0 16px 16px 16px;
  border-bottom: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};

  .ant-select {
    width: 100%;
  }
`;

export const RadioWrapper = styled.div`
  border-bottom: 1px solid ${COLOR_OPTIONS.NEUTRAL_20};
`;

const SubTitle = styled(Typography.Text).attrs({ type: 'secondary' })`
  font-size: 12px;
`;

export const CheckboxDescription = styled(SubTitle)`
  padding: 0 16px 12px;
  display: block;
`;

export const CheckboxWrapper = styled.div`
  height: 330px;
  overflow: scroll;

  .ant-checkbox-group {
    padding: 0 16px 12px 40px;
    gap: 10px;
    display: flex;
    flex-flow: column;

    .ant-checkbox-wrapper {
      .ant-checkbox + span {
        width: 100%;
      }
    }
  }
`;
